<template>
  <div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
      <div class="page-content">
        <SecondaryHeader @openSidepane="onClickChild" />
        <!---------------Tab Container---------------------->
        <b-card no-body :class="bodyPanel">
          <div v-if="notabvisible">
            <h4 class="disclaimerText">
              You do not have any access to view these tabs.
            </h4>
          </div>
          <div v-else>
            <div class="row iMost_kpi" style="">
              <div class="col-md-8">
                <h5>Microsoft</h5>
                <div class="float-left">
                  Reuters: MSFT.OQ
                  <br />
                  North America
                </div>
                <div class="float-right">
                  Bloomberg: MSFT UW
                  <br />
                  Infrastructure Software
                </div>
              </div>
              <div class="col-md-4">
                <!-- <h5>Microsoft</h5> -->
                <table class="table">
                  <tbody>
                    <tr>
                      <td>Target price (Analyst)</td>
                      <td>$32.65</td>
                    </tr>
                    <tr>
                      <td>Price (24 July 21)</td>
                      <td>$31.82</td>
                    </tr>
                    <tr>
                      <td>Target Price (User)</td>
                      <td id="targetPriceUser">$29.03</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <b-tabs card>
              <b-tab
                :active="value.activeToggle"
                v-for="(value, index) in iMostChildren"
                v-bind:key="index"
                :title-link-class="{'d-none':!value.is_visible}"
                :title="value.objectname"
                @click="
                  !value.activeToggle
                    ? navigateTab(`${value.objectname}`)
                    : () => {}
                "
              >
                <b-card-text>
                  <component v-bind:is="component[index]"></component>
                </b-card-text>
              </b-tab>
              <router-view></router-view>
            </b-tabs>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
//Import Packages
import jquery from "jquery";
import { mapGetters, mapActions } from "vuex";

//Import Components
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader from "@/components/BaseFiles/SecondHeader.vue";

// Import Images
import bgImage from "@/assets/img/dbTiles/BG.png";

export default {
  name: "SenstivityTable",
  components: {
    TopHeader,
    SecondaryHeader,
  },
  data() {
    return {
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      pageHead: "Senstivity Table",
      childArr: null,
      component: [],
      bodyPanel: "bodyPanelOpen",
      notabvisible: false
    };
  },
  computed: {
    ...mapGetters({
      iMost: "iMost",
    }),
    iMostChildren() {
      return this.iMost.child;
    },
  },
  created() {},
  methods: {
    ...mapActions(["getChartDataById"]),
    onClickChild(value) {
      if (value) {
        this.bodyPanel = "bodyPanel";
      } else {
        this.bodyPanel = "bodyPanelOpen";
      }
    },
    navigateTab(tabName) {
      // console.log('tab name---',tabName.toLowerCase().replace(/\s/g, ''));
      this.$router.push({ name: tabName.toLowerCase().replace(/\s/g, "") });
      // let filterChart = this.iMostChildren.filter(
      //   (item) => tabName === item.objectname
      // );
      let filterChart = this.getChildChartInfoByName(tabName);
      // let chartName = chartinfo.objectname;
      // console.log("filterChart--", filterChart);
      if (filterChart[0].child.length > 0) {
        let tabChild = filterChart[0].child;
        for (var i = 0; i < tabChild.length; i++) {
          this.getChartDataById({
            id: tabChild[i].chartId,
            chartName: tabChild[i].name,
          });
        }
      } else {
        this.getChartDataById({
          id: filterChart[0].chartId,
          chartName: filterChart[0].objectname,
        });
      }
    },
    getChildChartInfoByName(tabName) {
      let filterChart = this.iMostChildren.filter((item) => {
        if (tabName === item.objectname) {
          item.activeToggle = true;
          // console.log("+++++++++++++++", item.child);
          for (let i = 0; i < item.child.length; i++) {
            if (i == 0) {
              item.child[i].activeToggle = true;
            } else {
              item.child[i].activeToggle = false;
            }
          }
          return true;
        } else {
          item.activeToggle = false;
        }
      });
      // console.log("filterChart[0]", filterChart[0]);
      return filterChart;
    },
  },
  mounted() {
    if (
      this.$route.path == "/Sensitivity_Table" ||
      this.$route.path == "/Sensitivity_Table/"
    ) {
      let filterChart = null
      for(let [ii,dd] of this.iMostChildren.entries()){
        if(dd.is_visible){
          filterChart = dd
          filterChart.activeToggle = true
          break;
        }
      }
      if(filterChart == null) { 
        this.notabvisible = true 
        return
      }
      if (filterChart.child.length > 0) {
        let tabChild = filterChart.child;
        for (var i = 0; i < tabChild.length; i++) {
          this.getChartDataById({
            id: tabChild[i].chartId,
            chartName: tabChild[i].objectname,
          });
        }
      } else {
        this.getChartDataById({
          id: filterChart.chartId,
          chartName: filterChart.objectname,
        });
      }

      this.$router.push("/Sensitivity_Table/"+ filterChart.objectname.toLowerCase().replace(/ /g, "").replace(/-/g, "").replace(/\//g, ""));
    } else {
      for(let [ii,dd] of this.iMostChildren.entries()){
          if(this.$route.path == `/Sensitivity_Table/${dd.objectname.toLowerCase().replace(/ /g, "")}`){
            if(!dd.is_visible){
              this.notabvisible = true 
              return
            }
          }
        }
      const tab = this.$route.path.replace("/Sensitivity_Table/", "");
      let filterChart = this.iMostChildren.filter((item) => {
        let itemobName = item.objectname
          .toLowerCase()
          .replace(/ /g, "")
          .replace(/-/g, "")
          .replace(/\//g, "");
        if (tab === itemobName) {
          item.activeToggle = true;
          return true;
        } else {
          item.activeToggle = false;
          return false;
        }
      });
      // console.log("filterChart--!!", filterChart);
      if (
        filterChart &&
        filterChart.length &&
        filterChart[0] &&
        filterChart[0].child &&
        filterChart[0].child.length > 0
      ) {
        let tabChild = filterChart[0].child;
        for (let i = 0; i < tabChild.length; i++) {
          this.getChartDataById({
            id: tabChild[i].chartId,
            chartName: tabChild[i].objectname,
          });
        }
      } else {
        this.getChartDataById({
          id: filterChart[0].chartId,
          chartName: filterChart[0].objectname,
        });
      }
      // this.$router.push("/Sensitivity_Table/snapshot");
    }
  },
};
</script>

<style scoped>
.iMost_kpi {
  height: auto;
  background: #7158ce;
  color: #fff;
  font-size: 12px;
  padding: 0 10px;
}
.iMost_kpi h5 {
  font-weight: 600;
  /* border-bottom: 2px solid; */
  padding-bottom: 5px;
  margin-bottom: 0;
  text-decoration: underline;
}
.iMost_kpi .table {
  margin-bottom: 0px;
}
.fullscreen .snapShotPanel {
  max-height: 95vh !important;
  overflow: auto;
}
.iMost_kpi .table > tbody > tr > td,
.iMost_kpi .table > tbody > tr > th,
.iMost_kpi .table > tfoot > tr > td,
.iMost_kpi .table > tfoot > tr > th,
.iMost_kpi .table > thead > tr > td,
.iMost_kpi .table > thead > tr > th {
  padding: 2px;
  border-bottom: 1px dashed #ddd;
  border-top: unset;
  font-size: 12px;
  color: #fff;
}
</style>
